import 'css-chunksrc/client/scenes/task/allocations/styles.scss';export default {
  "allocations": "_allocations_1g4gg_1",
  "main": "_main_1g4gg_6",
  "item": "_item_1g4gg_11",
  "empty": "_empty_1g4gg_15",
  "emptyText": "_emptyText_1g4gg_25",
  "addAllocation": "_addAllocation_1g4gg_30",
  "iconBox": "_iconBox_1g4gg_35",
  "icon": "_icon_1g4gg_35",
  "list": "_list_1g4gg_44"
};